export default function PHP_Arrays() {
  return (
    <div>
      <h1>PHP_Arrays</h1>
    </div>
  );
}
